import { AntragsFlag, AntragsType } from '@ebeihilfe/core';

export class AntragFinishDto {
  public antragsId: string;
  public numberOfBelege: string;
  public numberOfPages: string;
  public typeOfAntrag: AntragsType;
  public antragCreationDate: Date;
  public encryptedMetadata: string;
  public flags: AntragsFlag[];

  constructor(
    antragsId: string,
    numberOfBelege: string,
    numberOfPages: string,
    typeOfAntrag: AntragsType,
    antragCreationDate: Date,
    encryptedMetadata: string,
    flags: AntragsFlag[],
  ) {
    this.antragsId = antragsId;
    this.numberOfBelege = numberOfBelege;
    this.numberOfPages = numberOfPages;
    this.typeOfAntrag = typeOfAntrag;
    this.antragCreationDate = antragCreationDate;
    this.encryptedMetadata = encryptedMetadata;
    this.flags = flags;
  }
}
